// JQUERY //
// import $ from "jquery";

// BOOTSTRAP //
import {
    Dropdown,
    Collapse,
    Modal,
    Tab,
    ScrollSpy,
    Offcanvas,
} from 'bootstrap';

// IMPORTS //
// import './custom/megamenu';
// import './custom/contain';

// Variabili
// let scrollPosition = window.scrollY;
// let body = document.querySelector('body');

// // Funzioni header
// let header = document.querySelector('header');
// let headerH = header.clientHeight;

// let pageMenu = document.querySelector('.page-menu');

// // Riduce header post scroll
// window.onload = function() {
// minifyHeader()
// };
// window.onscroll = function() {
// minifyHeader()
// };

// function minifyHeader() {
// if (document.body.scrollTop > headerH / 2 || document.documentElement.scrollTop > headerH / 2) {
//     body.classList.add('minified');
// } else {
//     body.classList.remove('minified');
// }
// }

// Focus su campo di ricerca
const searchPanel = document.getElementById('search-panel')
if (searchPanel) {
    searchPanel.addEventListener('shown.bs.collapse', function () {
        searchPanel.querySelector('.form-control').focus();
    })
}

// PLUGINS //
// Lazysizes
// import lazySizes from 'lazysizes';

// Lightbox
import GLightbox from 'glightbox';
const lightbox = GLightbox({
    loop: true
});

// Single Lightbox
const singleLightbox = GLightbox({
    loop: false
});

const singleLightboxElements = document.querySelectorAll('.glightbox-single');
if (singleLightboxElements) {
    singleLightboxElements.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            let targetHref = this.getAttribute('href');
            singleLightbox.setElements([{
                'href': targetHref
            }]);
            singleLightbox.open();
        })
    })
}

// Aos
import AOS from 'aos';
AOS.init({
    duration: 200,
    once: true,
});

// Smooth Scroll
const links = document.querySelectorAll(".pillar-anchor, .blog-btt");

for (const link of links) {
    link.addEventListener("click", smoothFn);
}

function smoothFn(e) {
    e.preventDefault();
    const href = this.getAttribute("href");
    let headerHeight = document.querySelector('.header').clientHeight;
    const offsetTop = document.querySelector(href).offsetTop - headerHeight;
    scroll({
        top: offsetTop,
        behavior: "smooth"
    });
}
// import Gumshoe from 'gumshoejs';

// Plyr
import Plyr from 'plyr';
const vid_player = Plyr.setup('.video-player', {
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
    ],
    youtube: {
        noCookie: true,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
    },
    vimeo: {
        byline: false,
        portrait: false,
        title: false,
        speed: true,
        transparent: false
    }
});
const vid_player_nc = Plyr.setup('.video-player-nc', {
    controls: [],
    youtube: {
        noCookie: true,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
    },
    vimeo: {
        byline: false,
        portrait: false,
        title: false,
        speed: true,
        transparent: false
    },
    muted: true,
    clickToPlay: false
});

// Swiper
import Swiper, {
    Navigation,
    Pagination,
    Autoplay,
    EffectFade
} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

// Homepage Slider
let homepage_slider = new Swiper(".homepage-slider", {
    loop: true,
    spaceBetween: 0,
    allowTouchMove: false,
    speed: 1000,
    // autoplay: {
    //     delay: 7000,
    // },
    pagination: {
        el: '.visual-pagination',
        type: 'bullets',
        clickable: true,
        bulletClass: 'bullet',
        bulletActiveClass: 'active'
    },
});

// Homepage Slider 1
if (document.querySelector(".homepage-slider1")) {
    let homepage_slider1 = new Swiper(".homepage-slider1", {
        loop: true,
        spaceBetween: 0,
        speed: 1000,
        autoplay: {
            delay: 7000,
        },
        pagination: {
            el: '.visual-pagination',
            type: 'bullets',
            clickable: true,
            bulletClass: 'bullet',
            bulletActiveClass: 'active'
        },
    });
}

// Gallery Slider
let gallerySlider = new Swiper('.gallery-slider', {
    spaceBetween: 32,
    autoHeight: false,
    loop: true,
    watchOverflow: true,
    speed: 500,
    // pagination: {
    //     el: '.gallery-pagination',
    //     type: 'bullets',
    //     clickable: true,
    // },
    navigation: {
        nextEl: ".gallery-nav.next",
        prevEl: ".gallery-nav.prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        }
    }
});

// Column Slider
let colSlider = new Swiper('.col-slider', {
    spaceBetween: 0,
    autoHeight: false,
    loop: true,
    watchOverflow: true,
    speed: 500,
    slidesPerView: 1,
    pagination: {
        el: '.col-pagination',
        type: 'bullets',
        clickable: true,
    },
    // navigation: {
    //     nextEl: ".gallery-nav.next",
    //     prevEl: ".gallery-nav.prev",
    // },
});

// Timeline Slider
let timelineSlider = new Swiper('.timeline-slider', {
    spaceBetween: 0,
    autoHeight: false,
    loop: false,
    speed: 500,
    pagination: {
        el: '.timeline-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: true,
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
        },
        576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        1200: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        }
    }
});

// Review Slider
let reviewSlider = new Swiper('.reviews-slider', {
    spaceBetween: 0,
    autoHeight: false,
    loop: true,
    speed: 500,
    effect: 'fade',
    crossFade: true,
    slidesPerView: 1,
    pagination: {
        el: '.reviews-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: ".review-nav.next",
        prevEl: ".review-nav.prev",
    },
});

// Form floater
let formFields = document.querySelectorAll('.form-float .form-control, .form-float .form-select');

formFields.forEach(function (el) {

    // Imposta placeholder
    el.setAttribute('placeholder', '');
    // Aggiunge classe di BS5
    el.parentNode.classList.add('form-floating')
    // Prende il tag label
    let label = el.parentNode.parentNode.querySelector("label");
    // Sposta label nello stesso nodo dell'input
    el.parentNode.append(label)

});

// Accordion repositioner
const accordionItems = document.querySelectorAll('.accordion-collapse');
const accordionWrapper = document.querySelector('.accordion');

accordionItems.forEach((el) => {
    el.addEventListener('shown.bs.collapse', (e) => {
        let headerHeight = document.querySelector('.header').clientHeight;
        let scrollOffset = accordionWrapper.scrollTop + el.parentNode.offsetTop - headerHeight;
        // console.log(scrollOffset);
        window.scroll({
            top: scrollOffset,
            left: 0,
            behavior: 'smooth'
        });
    })
});

// Hover intent
import './custom/hoverintent';

// get top-level items from a dropdown menu
var menuItems = document.querySelectorAll('.nav-item.dropdown');

// Touch device recognition
function isTouchDevice() {
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}

if (isTouchDevice() === true) {
    // console.log('Touch Device');
    menuItems.forEach(function (it) {
        it.classList.add('touch-device');
    });
} else {
    // console.log('Not a Touch Device');

    // set actions for mouse over and mouse leave
    var hi = new BZN.HoverIntent(menuItems, {
        // required parameters
        onEnter: function (targetItem) {
            targetItem.classList.add('visible');
        },
        onExit: function (targetItem) {
            targetItem.classList.remove('visible');
        },

        // default options
        exitDelay: 400,
        interval: 100,
        sensitivity: 7,
    });

}

// BIZEN
// document.addEventListener("DOMContentLoaded", function() {
console.log('A DIGITAL PROJECT BY\n\r······································································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo······················oooo·······································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo····oooooo············oooo······oooooooooooooooo·········ooooooooo···············oooooooooo······\n\r·oooooooooooooooooo········oooo·····ooooooooooooooooo······ooooooooooooooo·········oooooooooooooooo···\n\r·oooooooo······ooooo·······oooo················ooooo·····ooooo·········ooooo·····ooooo··········ooooo·\n\r·ooooo···········ooooo·····oooo··············ooooo······ooooo···········ooooo····ooo·············oooo·\n\r·oooo·············oooo·····oooo·············ooooo·······ooooooooooooooooooooo···oooo··············ooo·\n\r·oooo·············oooo·····oooo···········ooooo·········oooo····················oooo··············ooo·\n\r·oooo·············oooo·····oooo··········oooo···········oooo····················oooo··············ooo·\n\r··ooooo·········ooooo······oooo········ooooo·············oooo···········oooo····oooo··············ooo·\n\r····oooooooooooooooo·······oooo······ooooooooooooooo······oooooo······ooooo·····oooo··············ooo·\n\r·······oooooooooo··········oooo·····ooooooooooooooooo········oooooooooooo·······oooo··············ooo·\n\r······································································································\n\r');
// });
